/**
 * @generated SignedSource<<6b02fa9530edb2774bcb4542180b124f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedFeaturedRelatedItemsCarouselLazy_viewer$data = {
  readonly sponsoredItems: {
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFeaturedRelatedItemsCarousel_sponsoredItems">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFeaturedRelatedItemsCarousel_viewer">;
  readonly " $fragmentType": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer";
};
export type PdpSharedFeaturedRelatedItemsCarouselLazy_viewer$key = {
  readonly " $data"?: PdpSharedFeaturedRelatedItemsCarouselLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedFeaturedRelatedItemsCarouselLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "guestId"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "maxSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "minSponsoredItemsSteps"
    },
    {
      "kind": "RootArgument",
      "name": "numOfSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedFeaturedRelatedItemsCarouselLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedFeaturedRelatedItemsCarousel_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "guestId",
          "variableName": "guestId"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId"
        },
        {
          "kind": "Variable",
          "name": "maxItems",
          "variableName": "maxSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "minItemsSteps",
          "variableName": "minSponsoredItemsSteps"
        },
        {
          "kind": "Variable",
          "name": "pageSize",
          "variableName": "numOfSponsoredItems"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "SponsoredItems",
      "kind": "LinkedField",
      "name": "sponsoredItems",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFeaturedRelatedItemsCarousel_sponsoredItems"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e28c74fe43a92717630f464b2a4f8314";

export default node;
